<template>
  <div class="x-border-50 x-margin-b" data-automation="apiStepOne">
    <my-head-title :title="$t('HT.apiStepOne.title')"></my-head-title>
    <div class="x-flex-justify x-padding">
      <ux-form
        ref="form"
        :data="formData"
        width="550px"
        :colon="true"
        :rules="rules"
        label-width="110px"
        :hideBtn="true"
      >
        <ux-form-item :label="$t('HT.apiStepOne.groupId')" prop="group_id">
          <ux-select
            v-model="formData.group_id"
            :disabled="isEdit"
            clearable
            :options="groupList"
            :props="{ label: 'name', value: 'id' }"
          ></ux-select>
        </ux-form-item>
        <ux-form-item :label="$t('HT.apiStepOne.name')" prop="name">
          <ux-input
            v-model="formData.name"
            :maxlength="50"
            :placeholder="$t('HT.pleaseInput')"
          ></ux-input>
        </ux-form-item>
        <ux-form-item :label="$t('HT.apiStepOne.type')" prop="safety_certification.type">
          <ux-select
            v-model="formData.safety_certification.type"
            :options="$opt.safeList"
            @change="onchange"
          ></ux-select>
        </ux-form-item>

        <!-- 安全认证下API类型 -->
        <template
          v-if="
            formData.safety_certification.type === 'OPEN_ID' ||
            formData.safety_certification.type === 'APP_AND_OPEN_ID'
          "
        >
          <ux-form-item
            :label="$t('HT.apiStepOne.apiType')"
            :optionText="false"
            prop="safety_certification.api_type"
          >
            <ux-select
              v-model="formData.safety_certification.api_type"
              :options="$opt.apiList"
              @change="changeApi"
            ></ux-select>
          </ux-form-item>
          <template v-if="formData.safety_certification.api_type === 'AUTH'">
            <ux-form-item
              label="client_id"
              :optionText="false"
              prop="safety_certification.client_id"
            >
              <ux-input
                v-model="formData.safety_certification.client_id"
                :maxlength="50"
                :placeholder="$t('HT.pleaseInput')"
              ></ux-input>
            </ux-form-item>
            <ux-form-item
              label="client_secret"
              :optionText="false"
              prop="safety_certification.client_secret"
            >
              <ux-input
                v-model="formData.safety_certification.client_secret"
                :maxlength="50"
                :placeholder="$t('HT.pleaseInput')"
              ></ux-input>
            </ux-form-item>
          </template>
          <div class="professionalApi" v-if="formData.safety_certification.api_type === 'BUSINESS'">
            <ux-form-item
              label="token参数名"
              :optionText="false"
              prop="safety_certification.token_name"
            >
              <ux-input
                v-model="formData.safety_certification.token_name"
                :maxlength="50"
                :placeholder="$t('HT.pleaseInput')"
              ></ux-input>
            </ux-form-item>
          </div>
        </template>

        <!-- 安全认证下AppCode -->
        <template
          v-if="
            formData.safety_certification.type === 'APP' ||
            formData.safety_certification.type === 'APP_AND_OPEN_ID'
          "
        >
          <ux-form-item
            :label="$t('HT.apiStepOne.appCodeAuth')"
            :optionText="false"
            prop="safety_certification.app_auth_type"
          >
            <ux-select
              v-model="formData.safety_certification.app_auth_type"
              :options="$opt.codeList"
              @change="changeApp"
            ></ux-select>
          </ux-form-item>
          <ux-form-item
            :label="$t('HT.apiStepOne.appCodeParams')"
            v-if="
              formData.safety_certification.app_auth_type === null ||
              formData.safety_certification.app_auth_type === 'HEADER_AND_QUERY' ||
              formData.safety_certification.app_auth_type === 'HEADER'
            "
            :optionText="false"
            prop="safety_certification.app_auth_param_name"
          >
            <ux-input
              v-model="formData.safety_certification.app_auth_param_name"
              :maxlength="50"
              :placeholder="$t('HT.pleaseInput')"
            ></ux-input>
          </ux-form-item>
          <ux-form-item
            :label="$t('HT.apiStepOne.appCodeSign')"
            :optionText="false"
            prop="safety_certification.sign_auth"
          >
            <ux-select
              v-model="formData.safety_certification.sign_auth"
              :options="$opt.paramsList"
            ></ux-select>
          </ux-form-item>
        </template>

        <ux-form-item :label="$t('HT.apiStepOne.apiConfig')" prop="prevent_replay_attacks">
          <ux-checkbox v-model="formData.prevent_replay_attacks">{{
            $t('HT.apiStepOne.apiConfig.text')
          }}</ux-checkbox>
        </ux-form-item>
        <ux-form-item :label="$t('HT.apiStepOne.remark')" start prop="remark">
          <ux-input
            v-model="formData.remark"
            type="textarea"
            :autosize="{ minRows: 5, maxRows: 5 }"
            resize="none"
            :maxlength="1000"
            show-word-limit
          ></ux-input>
        </ux-form-item>
      </ux-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'apiStepOne',
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          group_id: '', // 所属分组
          name: '', // API名称
          remark: '', //描述
          safety_certification: {
            type: '', //安全认证
            app_auth_type: '', //
            app_auth_param_name: '', //AppCode对应的参数名
            api_type: '', //API类型ID
            client_id: '', //client_id
            client_secret: '', //client_secret
            token_name: '', //token对应的参数名
            sign_auth: '' //参数签名认证
          },
          prevent_replay_attacks: false //API配置
        };
      }
    }
  },
  data() {
    return {
      formData: this.data,
      rules: this.$rul.addApi(),
      isEdit: this.$route.query.id ? true : false, // 是否编辑
      groupList: [], // 分组列表数据
      flag: false
    };
  },

  created() {
    this.getList();
  },

  methods: {
    /**
     * 节流搜索
     */
    debounce: _.debounce(function (val) {
      this.getList(val);
    }, 300),

    /**
     * 输入远程搜索分组
     * @param {String} val 输入文字
     */
    filterMethod(val) {
      this.debounce(val);
    },

    /**
     * 获取列表
     * @param {String} name 分组名称
     */
    getList(name) {
      let postData = {
        name: name // 分组名称
      };
      this.$api.group.getList(postData).then((res) => {
        if (res.code == 10000) {
          this.groupList = res.data;
        }
      });
    },

    /**
     * 验证回调
     */
    confirm() {
      return new Promise((resolve) => {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            resolve(this.formData);
          }
        });
      });
    },

    /**
     * 选择框变动清空
     */
    onchange() {
      if (this.flag) {
        this.flag = false;
        return;
      }
      this.$set(this.formData.safety_certification, 'app_auth_param_name', null);
      this.$set(this.formData.safety_certification, 'client_id', null);
      this.$set(this.formData.safety_certification, 'client_secret', null);
      this.$set(this.formData.safety_certification, 'token_name', null);
      this.$set(this.formData.safety_certification, 'sign_auth', null);
      this.$set(this.formData.safety_certification, 'api_type', null);
      this.$set(this.formData.safety_certification, 'app_auth_type', null);
    },
    /**
     * 选择框变动清空
     */
    changeApi() {
      if (this.flag) {
        this.flag = false;
        return;
      }
      this.$set(this.formData.safety_certification, 'client_id', null);
      this.$set(this.formData.safety_certification, 'client_secret', null);
      this.$set(this.formData.safety_certification, 'token_name', null);
    },
    /**
     * 选择框变动清空
     */
    changeApp() {
      if (this.flag) {
        this.flag = false;
        return;
      }
      this.$set(this.formData.safety_certification, 'app_auth_param_name', null);
      this.$set(this.formData.safety_certification, 'sign_auth', null);
    }
  },

  watch: {
    data: {
      handler(val) {
        this.flag = true;
        this.formData = val;
      }
      // deep: true
    }
  }
};
</script>
